import { Chat } from '@apparel/core/chat/Chat';
import { ChatConfig } from '@apparel/core/chat/ChatConfig';
import React, { useEffect, useMemo, useReducer } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { ChatContextProvider, chatReducer } from './ChatContext';
import { ChatSocket } from './ChatSocket';
import { ChatState, ChatStateType } from './ChatState';

interface Props {
    children: any;
    value?: Partial<ChatStateType>;
    config?: Partial<ChatConfig>;
}

export function ChatProvider({ children, value, config }: Props) {
    const initialState = useMemo(() => new ChatState(value), []);
    const { auth, checking } = useAuth();
    const [state, dispatcher] = useReducer(chatReducer, initialState);
    initialState.setDispatcher(dispatcher);

    useEffect(() => {
        state.dispatch('updateState', value as any);
    }, [value, value?.room_id]);

    useEffect(() => {
        if (config) {
            Chat.configure(config);
        }
    }, [config]);

    useEffect(() => {
        if (auth) {
            state.dispatch('loadRooms');
        }
    }, [auth]);

    return (
        <ChatContextProvider value={state}>
            {auth && !checking ? <ChatSocket config={config} /> : null}
            {children}
        </ChatContextProvider>
    );
}
